var map = {
	"./APIS_refreshbutton.png": 540,
	"./APIS_swap_logo.png": 83,
	"./APIS_swap_logo_old.png": 541,
	"./coinbase_icon.png": 222,
	"./ic_arrow.svg": 36,
	"./ic_down.svg": 117,
	"./ic_home.svg": 118,
	"./ic_up.svg": 119,
	"./ic_wallet.svg": 120,
	"./main_bg.svg": 542,
	"./medium_icon.png": 223,
	"./platform_logo.svg": 121,
	"./swap_icon.svg": 122,
	"./swap_main_bg.svg": 543,
	"./telegram_icon.png": 224,
	"./tokenicon_apix.svg": 225,
	"./tokenicon_dash.svg": 226,
	"./tokenicon_weth.svg": 227,
	"./tokenicon_xzc.svg": 544,
	"./twitter_icon.png": 228,
	"./youtube_icon.png": 229
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12;